module.exports = __webpack_public_path__ + "static/media/autonomo.6f3f26c7.jpg";